/**
 * Checks if a function is callable.
 *
 * @param {any} func
 * @returns {boolean}
 */
export const isCallable = func => typeof func === 'function';
